// Product thresholds for diary prompts, not medical norms.
export const statisticsRules = {
  minimumLoggedDays: 4,
  minimumCoverage: 0.5,
  calorieUpper: 1.08,
  calorieLower: 0.82,
  proteinLower: 0.85,
  fatUpper: 1.15,
} as const;
